import { Text } from '@box/blueprint-web';
import classNames from 'classnames';
import React from 'react';
import { useShouldRenderBlueprint } from '../../../common/useShouldRenderBlueprint';
import VariantComponent from '../../../common/variant-component';
import css from './footer.module.scss';

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const OldMessageRow = (props: any) => {
  return (
    <div className={classNames(css.messageRow, css.grayText)} {...props} />
  );
};

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const NewMessageRow = (props: any) => {
  return (
    <Text
      as="p"
      className={css.messageRow}
      color="textOnLightDefault"
      variant="bodyDefault"
      {...props}
    />
  );
};

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const MessageRow = (props: any) => {
  // Should be addressed in FORMS-21241
  const shouldRenderBlueprint = useShouldRenderBlueprint();
  return (
    <VariantComponent
      NewComponent={NewMessageRow}
      OldComponent={OldMessageRow}
      shouldRenderNewComponent={shouldRenderBlueprint}
      {...props}
    />
  );
};

export default MessageRow;
